export interface CsvUpload {
  processedRowCount: number;
  successRowCount: number;
  errors?: string;
}

export enum CsvUploadStatus {
  NotStarted,
  Started,
  Success,
  ServerError,
  ExceedsAllowedFilesizeErrror,
  IncorrectFormatError,
  CompletedWithErrors,
}
